/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { typedDependencies } from './dependenciesTyped.generated.js';
import { createAbs } from '../../factoriesAny.js';
export var absDependencies = {
  typedDependencies,
  createAbs
};